/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                var _VERSION = 'Site Crescer :: 1.0.00';
                var _COPYRIGHT = ""
                    + "                                        \n"
                    + "                                        \n"
                    + "                                        \n"
                    + "              ,ZOOOOOOOO$.              \n"
                    + "          ZOOOOOOOOOOOOOOOOOO+          \n"
                    + "       :OOOOOOOOOOOOOOOOOOOOOOOO        \n"
                    + "     ,OOOOOOOOO +O: OOOOOOOOOOOOOO      \n"
                    + "    OOOOOOOOOOOOOO: OOOOOOOOOOOOOOOI            GLOVE IT, LDA      \n"
                    + "   OOOOOOOOOOOOOOO: OOOOOOOOOOOOOOOO~                              \n"
                    + "  ,OOOOOOOOOOOO 7O:    OOOOOOOOOOOOOO   Contacts: info@glove-it.pt \n"
                    + "  OOOOOOOOOOOOO 7O: OOOOOOOOOOOOOOOOO$  Address :                  \n"
                    + "  OOOOOOOOOOOOO 7O: OOOOOOOOOOOOOOOOOO  Largo da Praça do Peixe, 35, 1º Drt \n"
                    + "  OOOOOOOOOOOOO 7O: OOOOOOOOOOOOOOOOOO  3800-243 Aveiro \n"
                    + "  IOOOOOOOOOOOO 7O: OOOOOOOOOOOOOOOOO   \n"
                    + "   OOOOOOOOOOOO 7O: OOOOOOOOOOOOOOOOO   \n"
                    + "    OOOOOOOOOOO 7O~ OOOOOOOOOOOOOOOO    \n"
                    + "     OOOOOOOOOO 7OO  OOOOOOOOOOOOO+     \n"
                    + "       OOOOOOOOOOOOOOOOOOOOOOOOOZ       \n"
                    + "         ?OOOOOOOOOOOOOOOOOOOO,         \n"
                    + "            OOOOOOOOOOOOOO~             \n"
                    + "            OOOOOOOO                    \n"
                    + "           OOOOOOO                      \n"
                    + "          OOOOO                         \n"
                    + "         OO,                            \n"
                    + "                                        \n"
                    + "            www.glove-it.pt             \n";
                console.log(_COPYRIGHT + _VERSION);

                var videoIframe = $('.post .entry-content p > iframe');

                $(videoIframe).each(function() {
                    $(this).parent().find('br').remove();
                    $(this).parent().before(this);
                    $(this).wrap("<p class='embed-responsive embed-responsive-16by9'></p>");
                    $(this).addClass('embed-responsive-item');
                });

                $('.post .entry-content .wp-embedded-content').parent('p').removeClass('embed-responsive embed-responsive-16by9');

                // browser window scroll (in pixels) after which the "back to top" link is shown
                var offset = 300,
                    //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
                    offset_opacity = 1200,
                    //duration of the top scrolling animation (in ms)
                    scroll_top_duration = 700,
                    //grab the "back to top" link
                    $back_to_top = $('.cd-top');

                $(window).scroll(function () {
                    ($(this).scrollTop() > offset) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
                    if ($(this).scrollTop() > offset_opacity) {
                        $back_to_top.addClass('cd-fade-out');
                    }
                });

                //smooth scroll to top
                $back_to_top.on('click', function (event) {
                    event.preventDefault();
                    $('body,html').animate({
                            scrollTop: 0
                        }, scroll_top_duration
                    );
                });

                if (window.canRunAds === undefined) {
                    // adblocker detected, show fallback
                } else {

                    if ($("body").hasClass("category")) {
                        $('.pub-container-category').empty();
                        $('.pub-container-category').html('<!-- MPU APPNEXUS --><div data-pub="appNexus" data-pub-siteid="IMPALA_Crescer_Contigo" data-pub-pageid="HP_Homepage" data-pub-formatid="MPU" ></div><!-- / MPU APPNEXUS -->');
                    }
                }

                $('#carouselSingle').carousel({interval: false});
                $('#carouselSingle a[data-slide="prev"]').click(function () {
                    $('#carouselSingle').carousel('prev');
                    sendTraker();
                });

                $('#carouselSingle a[data-slide="next"]').click(function () {
                    $('#carouselSingle').carousel('next');
                    sendTraker();
                });

                $('#carouselSingle .carousel-indicators li').click(function () {
                    sendTraker();
                });


                $('#search-btn').click(function () {
                    $('#search-wrap').toggle();
                    $('#bottom-nav-wrap').toggle();
                    $('#searchform input').focus();
                });

                $('#search-sticky').click(function () {
                    $('#search-btn').trigger("click");
                });

                $('#search-btn-mobile').click(function () {
                    $('#search-wrap').toggle();
                    $('#searchform input').focus();
                });

                $('#search-btn-mobile-overlay').click(function () {
                    $('#search-wrap').show();
                    $("#closeNav").trigger("click");
                });

                $('#close-search').click(function () {
                    $('#search-wrap').hide();
                    $('#bottom-nav-wrap').show();
                });

                $('#hamburger-sticky').click(function () {
                    $("#hamburger").trigger("click");
                });

                $('#hamburger').click(function () {
                    $('#myNav').css('width', '340px');
                    $('.close-block').css('display', 'flex').hide().fadeIn();
                });

                $('#closeNav').click(function () {
                    $('#myNav').css('width', '0');
                    $('.close-block').fadeOut(300);
                });

                $('#share-sticky').click(function () {
                    $('.social-sticky').animate({width: 'toggle'}, 350);
                });

                $('#share-main').click(function () {
                    $('.social-main').animate({width: 'toggle'}, 350);
                });

                $("#comment-scroll").click(function () {
                    $("#post-read-more").trigger("click");
                    $('html, body').animate({
                        scrollTop: $(".fb-comments span").offset().top
                    }, 500);
                });

                $("#social-popup").click(function () {
                    $(".ssba.ssba-wrap").toggle("fast", function () {
                        // Animation complete.
                    });
                });

                function receiveMessage(event){
                    if (event.data==='removetheiframe'){
                        var element = document.getElementById('uon-adsrv');
                        element.parentNode.removeChild(element);
                        document.getElementsByClassName('iframe-holder')[0].remove();
                    }
                }

                $('#post-read-more').click(function () {
                    $('.post .middle-wrapper').css('max-height', '100%');
                    $('.post .read-more-container').css('display', 'none');
                    $('.post .content-bb').css('display', 'none');
                    $('.content-pub').css('margin-top', '30px');
                    sendTraker();
                    window.addEventListener('message', receiveMessage, false);
                    $('.iframe-holder').append('<iframe id="uon-adsrv" src="https://adsrv.youongroup.com/235/" width="100%" height="100%" scrolling="no" marginwidth="0" marginheight="0" frameborder="0" vspace="0" hspace="0" allowfullscreen webkitAllowFullScreen=1 mozallowfullscreen=1></iframe>');
                    $('.iframe-holder').css({'height': '100%', 'margin-bottom': '15px'});
                });

                $(window).on('load', function () {

                    var clickCounter = 1;
                    $('#carouselSingle').on('slide.bs.carousel', function () {
                        if ((clickCounter % 3) === 0) {
                            if (window.SAPO.CPU !== undefined) {
                                SAPO.CPU.refresh('[data-pub]:not(.do-not-refresh)');
                            }
                        }
                        clickCounter++;
                    });

                    var pubSingleH = $('.pub-half-single').offset();
                    function mrecSinglePos() {
                        if (pubSingleH === undefined || pubSingleH.left === 0) return;
                        var articleH = $('.entry-content .middle-wrapper').height();
                        var pubSingleHeight = $('.pub-half-single').height();
                        var sizeSingleDif = pubSingleH.top + articleH - pubSingleHeight;
                        if ($(window).scrollTop() > pubSingleH.top - 65) {
                            if ($(window).scrollTop() > sizeSingleDif) {
                                $('.pub-half-single').css({
                                    position: 'absolute',
                                    top: 'initial',
                                    left: 0,
                                    bottom: 0
                                });
                            } else {
                                $('.pub-half-single').css({
                                    position: 'fixed',
                                    top: 65,
                                    left: pubSingleH.left,
                                    bottom: 'initial'
                                });
                            }
                        } else {
                            $('.pub-half-single').css({
                                position: 'absolute',
                                top: 65,
                                left: 0,
                                bottom: 'initial'
                            });
                        }
                    }

                    $(window).scroll(function () {
                        mrecSinglePos();
                    });

                    $(window).resize(function () {
                        pubSingleH = $('.pub-half-single').offset();
                        mrecSinglePos();
                    });

                    mrecSinglePos();
                });

                $('.alm-load-more-btn').click(function () {
                    sendTraker();
                });


                //var stickyNavTop = $('#bottom-nav-wrap').offset().top;

                var stickyNav = function () {
                    var pubH = $('.sapo_takeover_theme_dark .sapo_takeover_iframe').height();
                    var impH = $('#impalaHeader').height();
                    var mainNavH = $('#mainNav').height();
                    var bottomNavH = $('#bottom-nav-wrap').height();
                    if ($(window).width() <= 1199) {
                        impH = 0;
                        mainNavH = 105;
                    }
                    if (pubH == null) {
                        pubH = 0;
                    }
                    var scrollTop = $(window).scrollTop();
                    var allH = pubH + impH + mainNavH;
                    $('#search-wrap').css('top', allH);
                    if (scrollTop >= allH) {
                        $('#bottom-nav-wrap').hide();
                        $('#sticky-nav-wrap').show().addClass('sticky');
                        if ($(window).width() > 1199) {
                            $('#search-wrap').addClass('sticky');
                            $('#mainNav').css('position', 'relative');
                            $('#search-wrap').css({'position': 'relative', 'top': 0});
                        }
                        else {
                            $('#mainNav').css('position', 'fixed');
                            $('#search-wrap').css({'position': 'fixed', 'top': mainNavH});
                        }
                    } else {
                        $('#sticky-nav-wrap').hide().removeClass('sticky');
                        $('#bottom-nav-wrap').show();
                        $('#mainNav').css('position', 'relative');
                        $('#search-wrap').css({'position': 'relative', 'top': 0});
                        if ($(window).width() > 1199) {
                            $("#closeNav").trigger("click");
                        }
                        $('#search-wrap').removeClass('sticky');
                    }
                };

                stickyNav();

                $(window).scroll(function () {
                    stickyNav();
                });

                $(window).resize(function () {
                    stickyNav();
                });

                $(".nav-item").click(function () {
                    $('.cat-border').css({width: '0'});
                    $(".nav-item").removeClass("active");
                    $('.sub-categories').slideUp();
                    var $this = $(this);
                    var cat = $this.attr("data-id");
                    var subId = $('#sub-categories' + cat);
                    if ($(subId).hasClass("open")) {
                        // already been clicked once, hide it
                        $(subId).slideUp();
                        $(subId).removeClass("open");
                        $this.removeClass("active");
                    }
                    else {
                        // first time this is clicked, mark it
                        $(subId).addClass("open");
                        $this.addClass("active");
                        $(subId).slideDown();
                    }
                });

                if ($(window).width() > 575) {

                    $(window).one('scroll', function() {
                        $("#btn-calendar").css("display", "flex")
                            .hide()
                            .fadeIn();
                    });

                    $("#btn-calendar").click(function () {
                        $(this).hide();
                        $("#caleandar").toggle("fast", function () {
                            // Animation complete.
                        });
                    });
                } else {
                    $("#btn-calendar").click(function () {
                        $("#caleandar").css({'bottom': '0'});
                    });
                }

                if ($("#caleandar").length) {
                    var events = [];
                    calendarOptions.forEach(function (item) {
                        events.push({
                            'Date': new Date(item.Date[0], item.Date[1] - 1, item.Date[2]),
                            'Year': item.Date[0],
                            'Month': item.Date[1],
                            'Day': item.Date[2],
                            'Title': '',
                            'Link': ''
                        });
                    });

                    var counts = {};
                    events.forEach(function (x) {
                        var num = counts[x.Date] = (counts[x.Date] || 0) + 1;
                        if (num === 1) {
                            x.Title = num + ' evento';
                        }
                        else {
                            x.Title = num + ' eventos';
                        }
                        x.Link = '/eventos/?d=' + x.Year + '' + x.Month + '' + x.Day;
                    });

                    var settings = {};
                    var element = document.getElementById('caleandar');
                    window.caleandarCallback = function () {
                        $('#caleandar .cld-main').append('<div class="calendar-close-mobile">' +
                            '<div id="btn-calendar-close">\n' +
                            '    <img src="/wp-content/themes/crescer/dist/images/close_calendar.png"\n' +
                            '         alt="Botão fechar calendário">\n' +
                            '</div>' +
                            '<h4>Agenda</h4>' +
                            '</div>');
                        if ($(window).width() > 575) {
                            $("#btn-calendar-close").click(function () {
                                $("#caleandar").toggle("fast", function () {
                                    // Animation complete.
                                });
                                $("#btn-calendar").fadeIn();
                            });
                        } else {
                            $("#btn-calendar-close").click(function () {
                                $("#caleandar").css('bottom', '-500px');
                                $("#btn-calendar").show();
                            });
                        }
                        $('.eventday').click(function () {
                            window.location = $(this).find("a").first().attr("href");
                            return false;
                        });
                    };
                    caleandar(element, events, settings);
                }

              $('#advanced-search-desktop').show();
              var catsDesktop = $('.cats-desktop ul');
              var catsDesktopBtn = $('.cats-desktop button');
              var tagsDesktop = $('.tags-desktop ul');
              var tagsDesktopBtn = $('.tags-desktop button');
              var cats = $('.cats ul');
              var catsBtn = $('.cats button');
              var tags = $('.tags ul');
              var tagsBtn = $('.tags button');

              function advancedSearch(el, btn) {
                if (el.height() > 50) {
                  el.css('height', 50);
                  btn.show();
                }
                btn.toggle(function () {
                  el.css('height', 'initial');
                  btn.text('Ver menos');
                }, function () {
                  el.css('height', 50);
                  btn.text('Ver todas');
                });
              }

              if ($(window).width() > 767) {
                advancedSearch(catsDesktop, catsDesktopBtn);
                advancedSearch(tagsDesktop, tagsDesktopBtn);
              }

              var checkboxDesktop = $('#advanced-search-desktop input[type=checkbox]');
              var checkbox = $('#advanced-search input[type=checkbox]');
              var isChecked = false;

              function checkboxWatcher(el) {
                $(el).on("change", function () {
                  if(isChecked) {
                    return;
                  }
                  var arrCats = [];
                  var arrTags = [];
                  var year = '';
                  $(el).each(function () {
                    if ($(this).is(":checked") && $(this).hasClass('cat')) {
                      arrCats.push($(this).val());
                    }
                    if ($(this).is(":checked") && $(this).hasClass('tag')) {
                      arrTags.push($(this).val());
                    }
                    if ($(this).is(":checked") && $(this).hasClass('year')) {
                      year = $(this).val();
                    }
                  });
                  checkboxDesktop.attr("disabled", true);
                  checkbox.attr("disabled", true);
                  isChecked = true;
                  var valCats = arrCats.join(",");
                  var valTags = arrTags.join(",");
                  if (valCats === '' && valTags === '' && year === '') {
                    window.location.href = baseUrl + '?s=' + searchText;
                  } else if (valCats !== '' && valTags === '' && year === '') {
                    window.location.href = baseUrl + '?s=' + searchText + '&c=' + valCats;
                  } else if (valCats === '' && valTags !== '' && year === '') {
                    window.location.href = baseUrl + '?s=' + searchText + '&t=' + valTags;
                  } else if (valCats !== '' && valTags !== '' && year === '') {
                    window.location.href = baseUrl + '?s=' + searchText + '&c=' + valCats + '&t=' + valTags;
                  } else if (valCats !== '' && valTags === '' && year !== '') {
                    window.location.href = baseUrl + '?s=' + searchText + '&c=' + valCats + '&y=' + year;
                  } else if (valCats === '' && valTags !== '' && year !== '') {
                    window.location.href = baseUrl + '?s=' + searchText + '&t=' + valTags + '&y=' + year;
                  } else if (valCats !== '' && valTags !== '' && year !== '') {
                    window.location.href = baseUrl + '?s=' + searchText + '&c=' + valCats + '&t=' + valTags + '&y=' + year;
                  } else if (valCats === '' && valTags === '' && year !== '') {
                    window.location.href = baseUrl + '?s=' + searchText + '&y=' + year;
                  }
                });
              }

              checkboxWatcher(checkboxDesktop);
              checkboxWatcher(checkbox);

              $('#show-advanced').toggle(function () {
                $('#advanced-search').show();
                $(this).find('.fa').toggleClass('fa-chevron-down fa-chevron-up');
                advancedSearch(cats, catsBtn);
                advancedSearch(tags, tagsBtn);
              }, function () {
                $('#advanced-search').hide();
                $(this).find('.fa').toggleClass('fa-chevron-up fa-chevron-down');
              });

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired

                function setboxHeight() {
                    var oh = $('.oh').height();
                    var colorRow = oh + 30;

                    $('.color-row').css('height', colorRow);
                }

                setboxHeight();

                $(window).resize(function () {
                    setboxHeight();
                    if ($(window).width() >= 1200) {
                        $("#closeNav").trigger("click");
                    }
                });

                $(window).scroll(function () {
                    setboxHeight();
                });
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page

                $('.carousel').each(function () {
                    var $carousel = $(this);
                    var hammertime = new Hammer(this, {
                        recognizers: [
                            [Hammer.Swipe, {direction: Hammer.DIRECTION_HORIZONTAL}]
                        ]
                    });
                    hammertime.on('swipeleft', function () {
                        $carousel.carousel('next');
                    });
                    hammertime.on('swiperight', function () {
                        $carousel.carousel('prev');
                    });
                });

                if (window.canRunAds === undefined) {
                    // adblocker detected, show fallback
                } else {
                    $('.destaques-pub').empty();
                    $('.pub-container-gravidez-4').empty();
                    $('.pub-container-gravidez-8').empty();
                    $('.pub-container-recem-nados').empty();
                    $('.pub-container-bebescriancas-4').empty();
                    $('.pub-container-bebescriancas-8').empty();

                    $('.destaques-pub').html('<!-- destaques-pub --><div data-pub="appNexus" data-pub-siteid="IMPALA_Crescer_Contigo" data-pub-pageid="HP_Homepage" data-pub-formatid="Halfpage" ></div><!-- / destaques-pub -->');

                    $('.pub-container-gravidez-4').addClass('d-none d-lg-block').html('<!-- pub-container-gravidez-4 --><div data-pub="appNexus" data-pub-siteid="IMPALA_Crescer_Contigo" data-pub-pageid="HP_Homepage" data-pub-formatid="MPU" ></div><!-- / pub-container-gravidez-4 -->');

                    $('.pub-container-gravidez-8').addClass('d-none d-lg-block').html('<!-- pub-container-gravidez-8 --><div data-pub="appNexus" data-pub-siteid="IMPALA_Crescer_Contigo" data-pub-pageid="HP_Homepage" data-pub-formatid="MPU" ></div><!-- / pub-container-gravidez-8 -->');

                    $('.pub-container-recem-nados').html('<!-- pub-container-recem-nados --><div data-pub="appNexus" data-pub-siteid="IMPALA_Crescer_Contigo" data-pub-pageid="HP_Homepage" data-pub-formatid="MPU" ></div><!-- / pub-container-recem-nados -->');

                    $('.pub-container-bebescriancas-4').html('<!-- pub-container-bebescriancas-4 --><div data-pub="appNexus" data-pub-siteid="IMPALA_Crescer_Contigo" data-pub-pageid="HP_Homepage" data-pub-formatid="MPU" ></div><!-- / pub-container-bebescriancas-4 -->');

                    $('.pub-container-bebescriancas-8').html('<!-- pub-container-bebescriancas-8 --><div data-pub="appNexus" data-pub-siteid="IMPALA_Crescer_Contigo" data-pub-pageid="HP_Homepage" data-pub-formatid="MPU" ></div><!-- / pub-container-bebescriancas-8 -->');
                }

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

    function resizeShapeRevista(){
        width_capa_revista = $('img.capa-revista').width();
        height_capa_revista = $('img.capa-revista').height();
        $('.shape-capa-share').width(width_capa_revista).height(height_capa_revista);
        $('.shape-capa-share').css('line-height', height_capa_revista + 'px');
    }

    $( window ).resize(function() {
        resizeShapeRevista();
    })

    $('.fashare').click(function(){
        $('.shape-capa-share').toggle();
        resizeShapeRevista();
    });

    $('#share-facebook').click(function() {

        var url = "";
        purl = $(this).attr('data-purl');
        ptitle = $(this).attr('data-ptitle');
        pimg = $(this).attr('data-pimg');
        text = $(this).attr('data-text');

        url = 'https://www.facebook.com/sharer.php?s=100';
        url += '&u=' + encodeURIComponent(purl);
        url += '&p[url]=' + encodeURIComponent(purl);
        url += '&p[images][0]=' + encodeURIComponent(pimg);
        url += '&p[title]=' + encodeURIComponent(ptitle);
        url += '&p[summary]=' + encodeURIComponent(text);
        window.open(url, '', 'toolbar=0,status=0,width=626, height=436');
    });

    $('#share-twitter').click(function() {

        var url = "";
        purl = $(this).attr('data-purl');
        ptitle = $(this).attr('data-ptitle');
        pimg = $(this).attr('data-pimg');
        text = $(this).attr('data-text');

        url = 'https://twitter.com/share?';
        url += 'text=' + encodeURIComponent(ptitle);
        url += '&url=' + encodeURIComponent(purl);
        url += '&counturl=' + encodeURIComponent(purl);
        window.open(url, '', 'toolbar=0,status=0,width=626, height=436');

    });

    $('#share-pinterest').click(function() {

        //https://pinterest.com/pin/create/bookmarklet/?media=[post-img]&url=[post-url]&description=[post-title]
        var url = "";
        purl = $(this).attr('data-purl');
        ptitle = $(this).attr('data-ptitle');
        pimg = $(this).attr('data-pimg');

        url = 'https://pinterest.com/pin/create/bookmarklet/?';
        url += 'media=' + encodeURIComponent(pimg);
        url += '&url=' + encodeURIComponent(purl);
        url += 'description=' + encodeURIComponent(ptitle);
        window.open(url, '', 'toolbar=0,status=0,width=626, height=436');

    });

})(jQuery); // Fully reference jQuery after this point.



